import React from "react";
import { Container } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import { FiArrowUpRight } from "react-icons/fi";
import blog from "../../Assets/Projects/blog.png";
import nav from "../../Assets/Projects/nav.png";
import manage from "../../Assets/Projects/manage.png";
import mypost from "../../Assets/Projects/mypost.png";
import sqlstudio from "../../Assets/Projects/sqlstudio.png";

const projects = [
  // Descriptions come from the public READMEs; app icons come from the same repositories.
  {
    id: "sqlstudio",
    category: "Desktop · Database tools",
    title: "SQLStudio",
    description:
      "An open-source database workspace for macOS and Windows. Query SQL databases, explore MongoDB and Redis, and compare or synchronize relational tables.",
    highlights: [
      "Data browsing, query editing, and schema inspection",
      "SQL import/export, schema comparison, and data sync",
    ],
    technologies: ["Electron", "React", "TypeScript"],
    imgPath: sqlstudio,
    imageAlt: "SQLStudio application icon",
    previewLabel: "SQLStudio",
    previewCaption: "Your data. One workspace.",
    repoLink: "https://github.com/Wayne-HJ/SQLStudio",
    featured: true,
  },
  {
    id: "mypost",
    category: "Desktop · API development",
    title: "Mypost",
    description:
      "A local-first API workbench for macOS and Windows. Organize HTTP requests, manage environments, and inspect responses without an account.",
    highlights: [
      "Collections, environments, and request history",
      "cURL import/export and Chinese/English interfaces",
    ],
    technologies: ["Electron", "React", "TypeScript"],
    imgPath: mypost,
    imageAlt: "Mypost application icon",
    previewLabel: "Mypost",
    previewCaption: "Your APIs. Your workspace.",
    repoLink: "https://github.com/Wayne-HJ/Mypost",
  },
  {
    id: "publishing",
    category: "Full-stack · Publishing",
    title: "Personal publishing platform",
    description:
      "A home for articles, conversations, and photo collections. Built with a Vue frontend and an independent Spring Boot API.",
    highlights: [
      "Articles, comments, and photo albums",
      "Real-time chat and messaging",
    ],
    technologies: ["Vue", "Spring Boot", "MySQL", "Redis", "RabbitMQ"],
    imgPath: blog,
    imageAlt: "Personal website homepage shown on a laptop",
    repoLink: "https://github.com/Wayne-HJ/personal-website",
  },
  {
    id: "admin",
    category: "Full-stack · Administration",
    title: "Content & access management",
    description:
      "One workspace to manage articles, pages, menus, and users. A Vue and Element UI interface backed by Spring Boot services.",
    highlights: [
      "User administration and access control",
      "Reusable components and modular APIs",
    ],
    technologies: ["Vue", "Element UI", "Spring Boot", "MySQL", "Redis"],
    imgPath: manage,
    imageAlt: "Content management platform login screen shown on a laptop",
    repoLink: "https://github.com/Wayne-HJ/vue-web-admin",
  },
  {
    id: "navigation",
    category: "Frontend · Everyday tools",
    title: "A simpler start to the web",
    description:
      "A lightweight start page that brings search engines, suggestions, and frequently used links into a single, focused interface.",
    highlights: [
      "Switch search engines in one place",
      "Quick links to everyday destinations",
    ],
    technologies: ["JavaScript", "HTML", "CSS"],
    imgPath: nav,
    imageAlt: "Navigation start page with a search bar and shortcut links",
    repoLink: "https://github.com/Wayne-HJ/navweb",
  },
];

function Projects() {
  return (
    <Container as="main" fluid className="project-section">
      <Container className="projects-container">
        <header className="projects-intro">
          <p className="projects-eyebrow">Portfolio / Selected work</p>
          <div className="projects-intro-row">
            <h1>Ideas into<br /><span>working software.</span></h1>
            <p className="projects-lead">
              From desktop developer tools to publishing platforms. A selection of my
              work across frontend, backend, and the pieces in between.
            </p>
          </div>
        </header>

        <div className="projects-section-label">
          <span>Selected projects</span>
          <span>01 — {String(projects.length).padStart(2, "0")}</span>
        </div>
        <div className="projects-grid">
          {projects.map((project, index) => (
            <ProjectCard key={project.id} {...project} number={index + 1} />
          ))}
        </div>

        <div className="projects-outro">
          <p>More code, experiments, and things in progress.</p>
          <a href="https://github.com/Wayne-HJ" target="_blank" rel="noopener noreferrer">
            Explore GitHub <FiArrowUpRight aria-hidden="true" />
          </a>
        </div>
      </Container>
    </Container>
  );
}

export default Projects;
